import styled from "@xstyled/styled-components";

import { Spacing, Text } from "@otta/design";
import { Tabs } from "@otta/search/components/Tabs";
import { CompanyFragment } from "@otta/search/schema";
import { TeamSize } from "@otta/search/components/MeetTheTeam/TeamSize";
import { MissionCard } from "@otta/search/components/MeetTheTeam/MissionCard";
import { pxToRem } from "@otta/design-tokens";
import { TeamAssets } from "@otta/search/components/MeetTheTeam/TeamAssets";
import { ManagerPrompts } from "@otta/search/components/MeetTheTeam/ManagerPrompts";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(24)};
`;

export function MeetTheTeam({
  teams,
}: {
  teams: CompanyFragment["teams"];
}): React.ReactElement {
  return (
    <Spacing size={1}>
      <Text bold size={1} data-testid="meet-the-team">
        Meet the team
      </Text>
      <Tabs
        tabs={teams.map(team => ({
          id: team.id,
          title: team.name,
          content: <MeetOneTeam team={team} />,
        }))}
      ></Tabs>
    </Spacing>
  );
}

function MeetOneTeam({
  team,
}: {
  team: CompanyFragment["teams"][0];
}): React.ReactElement {
  return (
    <Wrapper>
      {!!team.size && <TeamSize size={team.size} />}
      {!!team.mission && <MissionCard>{team.mission}</MissionCard>}
      <TeamAssets assets={team.brandAssetLinks} />
      <ManagerPrompts team={team} />
    </Wrapper>
  );
}
